module.exports = __webpack_public_path__ + "img/024-maloik.69f27985.svg";